import request from "./api_client";

const dataUrl = {
  // GET ALL DROP DOWN VALUES OF ORGANISATION STEPPER
  all_organisation_dropdowns: "/organisations/listing_dropdowns",
  listing_global_countries: "/rate_cards/listing_global_countries",
  all_employee_dropdowns: "/employees/listing_dropdowns",
  partner_profiles: "/partner_profiles/listing_dropdowns",

  // LIST ALL CITIES OF A COUNTRY
  listing_cities: "/organisations/listing_cities",

  listing_county: "/organisations/listing_states",

  // ORGANISATION LISTING
  organisations: "/organisations",
  employees: "/employees",

  // EMPLOYEE LISTING
  employee: "/organisations/fetch_general_detail",

  //  ORGANISATION CREATE - ORGANISATION DETAILS
  ownerships: "/ownerships",
  type_of_organisation: "/type_of_organisations",
  type_of_services: "/type_of_services",
  internal_status: "/internal_status",
  territories: "/territories",
  industry_sectors: "/industry_sectors",
  level_dropdown_values: "/level_dropdown_values",
  source_referral1: "/source_referral1",
  source_referral2: "/source_referral2",
  source_referral3: "/source_referral3",
  services_offered: "/services_offered",

  //  ORGANISATION CREATE - PROFILE
  currencies: "/currencies",
  employee_list: "/employee_list",
  countries: "/countries",

  //  ORGANISATION - CONTACT
  parent_organisations: "/parent_organisations",
  business_units: "/business_units",
  offices: "/offices",
  departments: "/departments",
  functions: "/functions",

  // ORGANISATION - PRECONTRACT
  org_profile_document_types: "/org_profile_document_types",

  // EMPLOYEE - CONTACT AREA
  languages: "/languages",

  // EMPLOYEE - WORK INFORMATION
  job_role_list: "/job_role_list",
  organisation_list: "/organisation_list",

  // EMPLOYEE - COACHING PROFILE
  diagnostic_tools: "/diagnostic_tools",
  client_types: "/client_types",
  areas_of_expertise: "/areas_of_expertise",

  // EMPLOYEE - GDPR
  purposes: "/purposes",

  // MASTER-TEMPLATE
  fetch_program_info: "master_templates/fetch_program_info",
  fetchMasterTemplateList: "/master_templates",
  fetch_service: "master_templates/fetch_services",

  //COACHING DIMENSIONS
  fetch_coaching_dimension: "/master_templates/fetch_coaching_dimensions",

  //COACHING COMMERCIALS AND BILLINGS

  //FETCH LEVELS
  fetch_levels_master_template: "master_templates/fetch_levels",
  fetch_commercial_billing: "master_templates/fetch_commercial_billing",

  //LISTING PROGRAM DOCUMENTS
  uploaded_document: "master_templates/listing_pgm_documents",

  //LISTING TERMS AND CONDITION
  terms_condition: "master_templates/fetch_terms_and_policies",

  //Dashboard
  dashboards_fetch_clients_data: "dashboards/fetch_clients_data",

  client_dashboards_top_five_clients: "client_dashboards/top_five_clients",

  client_dashboards_annual_revenue: "client_dashboards/annual_revenue",

  //PROGRAM FLOW SETUP
  program_flow_setup: "master_templates/fetch_pgm_flow_setup",
  show_selected_program_module: "master_templates/show_chosen_pgm_modules",

  //PROGRAM
  program_info: "programmes/fetch_program_info",
  coaching_dimensions: "/programmes/fetch_coaching_dimensions",
  fetch_level: "programmes/fetch_levels",
  commercial_billing: "programmes/fetch_commercial_billing",
  program_documents: "programmes/listing_pgm_documents",
  terms_policies: "programmes/fetch_terms_and_policies",
  flow_setup: "programmes/fetch_pgm_flow_setup",
  fetch_program: "programmes",
  list_all_drop_down_value: "organisations/listing_dropdowns",
  rate_card_info: "programmes/view_rate_card_info",
  program_price_summary: "programmes/fetch_price_summary",
  program_client_price_summary: "programmes/fetch_client_price_summary",
  program_supplier_price_summary: "programmes/fetch_supplier_price_summary",

  //ASSIGNMENTS
  assignment_program_info: "assignments/fetch_program_info",
  assignment_coaching_dimension: "assignments/fetch_coaching_dimensions",
  assignment_commercial_billing: "assignments/fetch_commercial_billing",
  assignment_fetch_levels: "/assignments/fetch_levels",
  assignment_program_flow: "/assignments/fetch_pgm_flow_setup",
  assignment_program_documents: "assignments/listing_pgm_documents",
  assignment_terms_policies: "assignments/fetch_terms_and_policies",
  list_all_assignments: "assignments",
  assignments_rate_card_info: "assignments/view_rate_card_info",
  assignment_price_summary: "assignments/fetch_price_summary",
  assignment_client_price_summary: "assignments/fetch_client_price_summary",
  assignment_evaluation_form_summary:
    "evaluation_forms/assignment_evaluation_form_summary",
  assignment_supplier_price_summary: "assignments/fetch_supplier_price_summary",

  //ASSIGNMENT SUMMARY
  session_detail: "assignment_summary/session_details",
  SLA_detail: "assignment_summary/SLA_details",
  monthwise_assignment_count_graph:
    "/dashboards/monthwise_assignment_count_graph",
  monthwise_assignment_duration_graph:
    "/dashboards/monthwise_assignment_duration_graph",

  //SLA
  fetch_SLA: "slas",
  fetch_Organisations: "slas/listing_organisations",
  fetch_sla_graph_data: "slas/sla_list",

  //NOTIFICATION
  fetch_notication: "notification_list",

  // REPORT SLA
  report_fetch_sla: "slas/sla_list",

  // EMAIL
  listing_email_address: "shortlisting_coaches/listing_email_address",
  get_email_content: "shortlisting_coaches/get_email_content",

  // FEEDBACK
  feedback_listing: "feedbacks",
  listing_feedback_dropdown: "feedbacks/listing_dropdowns",

  // REPORT
  report_fetch_oraganization: "feedbacks/collate_feedback",

  //FETCH LEVELS
  fetch_coaching_agreement: "coaching_agreement_forms/assignment_caf_summary",

  //FETCH COST
  fetch_cost: "assignment_summary/costs",

  //AcuityFeedback
  acuityFeedback: "acuity_feedbacks",

  //LISTING COUNTRY FOR SELECTION OF RATE CARD
  listing_countries_dropdown: "rate_cards/listing_global_countries",

  //LISTING STAKEHOLDER EMAIL
  listStakeholdersEmail: "session_details/fetch_stakeholders_emails",

  //Shortlisting coaches -send email - sessions outcomes
  outcomesSendEmail: "shortlisting_coaches/chemistry_session",

  //Shortlist emails existing data
  shortListExistingEmail: "shortlisting_coaches/populated_shortlist_email",
  mostUtilizedLocation: "dashboards/location_dropdown",
  miFieldsOrganisationList: "management_information_fields/organisation_list",

  miFieldListForToggle: "management_information_fields/mi_field_list",

  // internal Use only
  assignmentInternalDetails: "assignment_internal_details",
  sendToEmailShortlist: "shortlisting_coaches/send_to_email",
};

export function getData(params, section, url) {
  return request({
    url: url || dataUrl[section],
    method: "GET",
    params: params,
    paramsSerializer: (params) => {
      // Sample implementation of query string building
      let result = "";
      Object.keys(params).forEach((key) => {
        if (params[key] != null) {
          result += `${key}=${encodeURIComponent(params[key])}&`;
        }
      });
      return result.substr(0, result.length - 1);
    },
  });
}

const ListingService = {
  getData,
};

export default ListingService;
